module.exports = __webpack_public_path__ + "36c52ce36de9f27af52c2e7d1f0a4dcf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/lib/icon/iconfont.ttf?t=1552554261471
// module id = 14
// module chunks = 0